import "./FormDetail.scss";
import { useEffect, useState, useContext} from "react";
import {
  Col,
  Row,
  Modal,
  Checkbox,
  Button,
  Input,
  Spin,
  Popconfirm,
  Tooltip,
  Icon,
  Radio,
  Form, notification
} from "antd";
import { SectionEdit, Preview, ModalNewSection, FormEdit } from '../'
import { globalContext, formsContext } from "../../../../contexts";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useTranslation } from "react-i18next";
import { getTemplateVersionPromise } from "../../../AdminFormManager/promises/formManagerPromises";
import { getParamsUboFinderPromise } from "../../../InterestConflicts/promises";

import iconLangEs from '../../../../layouts/Private/components/Footer/assets/lang-es.png'
import iconLangBr from '../../../../layouts/Private/components/Footer/assets/lang-br.png'
import iconLangEn from '../../../../layouts/Private/components/Footer/assets/lang-en.png'

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  cursor: 'auto',
  ...draggableStyle
});


const FormDetail = ({ currentUser, templateId, templateVersionId, handleSaveTemplate, handleHasChanges, form: formDecorator }) => {
	const { t } = useTranslation('forms')
  const [form, setForm] = useState(null)
  const [templateVersion, setTemplateVersion] = useState(null)
  const [sections, setSections] = useState([])
  const [section, setSection] = useState(null)
  const { loadFormDatasource } = useContext(globalContext)
  const [isVisibleNewSection, setIsVisibleNewSection] = useState(false)
  const [mode, setMode] = useState('list')
  const [languages, setLanguages] = useState(["es"])
  const [lang, setLang] = useState("es")
  const [hasSign, setHasSign] = useState(false)
  const [hasSigner, setHasSigner] = useState(false)
  const { getFieldDecorator, validateFields, setFieldsValue } = formDecorator;

  useEffect(() => {
		loadForm()
	}, [])

  useEffect(() => {
    if (form && lang) {
      setFieldsValue({'form_title': form.title?.[lang] || ''});
    }
  }, [lang, form]);

  const loadForm = () => {
    getParamsUboFinderPromise(currentUser.cliente.id).then(r => {
      if(r?.data) {
        setHasSigner(r.data.firma !== "N");
      }
    })
    getTemplateVersionPromise(templateId, templateVersionId).then(templateVersion => {
      let form = {id: templateId, sections: [], title: {}}
      if(templateVersion?.objJson) {
        const json = templateVersion.objJson;
        form = {...form, ...json}
        if(json.languages) {
          setLanguages(json.languages)
          if(json.languages.length > 0) {
            setLang(json.languages[0])
          }
        }
      }
      setTemplateVersion(templateVersion)
      setForm(form)
      setSections(form.sections)
      setHasSign(form.hasSign)
    })
    loadFormDatasource(templateId)
  }

  const handlerAddSection = async (section) => {
    closeModalSectionHandler()

    let joined = sections.concat(section);
    setSections(joined)
    let f = await updateSections(joined)
    editSection(f.sections[f.sections.length-1])
  }

  const getRandomId = () => {
    return Math.floor(Math.random() * 1000000);
  }

  const createCloneId = (id) => {
    const originalId = String(id ?? '')
    const prefix = originalId.charAt(0)
    let newId
    do {
      const randomCode = getRandomId()
      newId = `${prefix}${randomCode}`
    } while(newId === originalId)
    return newId
  }

  const cloneSectionStructure = (value, clonedObjects = new WeakMap()) => {
    if(!value || typeof value !== 'object') return value
    if(clonedObjects.has(value)) return clonedObjects.get(value)

    const isArray = Array.isArray(value)
    const clone = isArray ? new Array(value.length) : Object.create(Object.getPrototypeOf(value))
    clonedObjects.set(value, clone)

    Reflect.ownKeys(value).forEach(key => {
      if(isArray && key === 'length') return
      if(typeof key === 'string' && ['record', 'risks'].includes(key)) return

      const descriptor = Object.getOwnPropertyDescriptor(value, key)
      if(Object.prototype.hasOwnProperty.call(descriptor, 'value')) {
        descriptor.value = key === 'id'
          ? createCloneId(descriptor.value)
          : cloneSectionStructure(descriptor.value, clonedObjects)
      }
      Object.defineProperty(clone, key, descriptor)
    })

    return clone
  }

  const cloneSection = (section) => {
    let newSec = [...sections]
    const newSection = {
      ...cloneSectionStructure(section),
      name: t('forms.manager.section.copyof',{name:section.name})
    }
    newSec.push(newSection)

    setSections(newSec);
    updateSections(newSec)
  }

  const deleteSection = (index) => {
    let sec = sections.filter((item, i) => i !== index)
    setSections(sec);

    updateSections(sec)
  }

  const handleChangeAttrSection = (index, key, value) => {
    let sec = sections.map((section, i) => {
      if (index == i) {
        return { ...section, [key]: value };
      } else {
        return section;
      }
    })
    setSections(sec)

    if(key !== 'title' && sec[index].type !== null && sec[index].type !== undefined) updateSections(sec)
  }

  const handleBlurTitle = () => {
    updateSections(sections)
  }

  const handleChangeName = (index, value) => {
    handleChangeAttrSection(index, 'name', value)
  }

  const changeActiveSection = (index, checked) => {
    handleChangeAttrSection(index, 'status', checked ? 'ACTIVE' : 'INACTIVE')
  }

  const getTypeSection = (type) => {
    return t(`forms.manager.section.type.${type}`)
  }

  const editSection = (s) => {
    s.formId = form.id
    const cloned = JSON.parse(JSON.stringify(s));
    setSection(cloned)
  }

  const closeSection = (changes) => {
    setSection(null)
    if(changes !== undefined) handleHasChanges(changes)
  }

  const refreshSection = (s) => {
    const _sections = sections.map((section, i) => {
        if (section.id === s.id) {
          return s;
        } else {
          return section;
        }
      }
    )
    updateSections(_sections)
    if(section !== null) setSection(s)
  }

  const updateSections = async (s) => {
    let f = { ...form, sections: s}
    setForm(f)
    setSections(f.sections)
    return f
  }

  const getStrLanguage = (l) => {
    if(l === "es") return "Español"
    else if(l === "en") return "Inglés"
    else if(l === "pt") return "Portugués"
  }

  const saveForm = () => {
    validateFields((err, values) => {
      if (!err) {

        let isValid = true;

        for (let l of languages) {
          if (!form.title?.[l] || form.title[l].trim() === '') {
            isValid = false;
            notification.error({
              message: 'Error',
              description: `Falta completar el título en el idioma: ${getStrLanguage(l)}`
            });
            break;
          }
        }

        if (!isValid) return;

        const payload = {
          sections,
          languages,
          hasSign,
          logo: form.logo,
          title: form.title
        };

        handleSaveTemplate(payload, templateVersion);
      }
    });
  }

  const openModalSectionHandler = () => {
    setIsVisibleNewSection(true)
  }

  const closeModalSectionHandler = () => {
    setIsVisibleNewSection(false)
  }

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const newIndex = result.destination.index
    const oldIndex = result.source.index
    if(newIndex === oldIndex) {
      return;
    }

    let sec = sections
    let newItem = sec[oldIndex]
    if(oldIndex > newIndex) {
      for(let i = oldIndex; i>newIndex; i--) {
        sec[i] = sec[i-1]
      }
    }else {
      for(let i = oldIndex; i < newIndex; i++) {
        sec[i] = sec[i+1]
      }
    }
    sec[newIndex] = newItem

    updateSections(sec)
  }

  const onChangeMode = (e) => {
    setMode(e.target.value)
  }

  const onChangeLanguages = (l) => {
    if(l.length === 0) {
      return
    }
    setLanguages(l)
    if(l.length > 0 && !l.includes(lang)) {
      setLang(l[0])
    }else if(l.length === 0) {
      setLang("all")
    }
  }

  const onChangeLang = (e) => {
    setLang(e.target.value)
  }

  const handleChangeSign = (e) => {
    setHasSign(e.target.checked)
  }

  const handleChangeTitle = (value) => {
    const updatedForm = {...form,
      title: {
        ...(form.title || {}),
        [lang]: value,
      },
    };
    setForm(updatedForm);
  };

  return (
    <div className="form-manager-detail">
      { form === null ? <Spin/>
        :
        <formsContext.Provider value={{formObj: form, templateVersion, sections, clientCountry: currentUser?.cliente?.pais}}>
          { section ?
            <SectionEdit
                    s={section}
                    refreshThisSection={refreshSection}
                    closeSection={closeSection}
                    languages={languages}
                    lang={lang}
                    onChangeLang={onChangeLang}
                    handleHasChanges={handleHasChanges}
                    mode="edit"
            />
          :
              <div className="form">
                <Row className="row-tools">
                  <Col span={3}>
                    {handleSaveTemplate &&
                        <Button onClick={openModalSectionHandler}
                                type="primary">{t('forms.manager.section.new.title')}</Button>
                    }
                  </Col>
                  <Col span={handleSaveTemplate ? 6 : 9} style={{textAlign: 'center'}}>
                    <label>{t("forms.manager.mode")}: </label>
                    <Radio.Group onChange={onChangeMode} defaultValue={mode} buttonStyle="solid" size="small">
                      <Radio.Button value="list"><Icon type="unordered-list"/>&nbsp;{t("forms.manager.list")}
                      </Radio.Button>
                      <Radio.Button value="design"><Icon type="form"/>&nbsp;{t("forms.manager.design")}</Radio.Button>
                      <Radio.Button value="preview"><Icon type="file-text"/>&nbsp;{t("forms.manager.preview")}
                      </Radio.Button>
                    </Radio.Group>
                  </Col>
                  {handleSaveTemplate &&
                      <Col span={5} style={{textAlign: 'center'}}>
                        <label>{t('forms.manager.section.languages')}: </label>
                        <Checkbox.Group
                            onChange={handleSaveTemplate && onChangeLanguages}
                            value={languages}
                            options={[
                              {label: <img className="language-icon" src={iconLangEs}/>, value: 'es'},
                              {label: <img className="language-icon" src={iconLangEn}/>, value: 'en'},
                              {label: <img className="language-icon" src={iconLangBr}/>, value: 'pt'},
                            ]}
                        />
                      </Col>
                  }
                  <Col span={handleSaveTemplate ? 4 : 6} style={{textAlign: 'center'}}>
                    <label>{t('forms.manager.section.language')}: </label>
                    {lang === "all" ?
                        <b>No definido</b>
                        :
                        <Radio.Group onChange={onChangeLang} value={lang} buttonStyle="solid" size="small">
                          {languages.includes("es") &&
                              <Radio.Button value="es"><img className="language-icon" src={iconLangEs}/></Radio.Button>}
                          {languages.includes("en") &&
                              <Radio.Button value="en"><img className="language-icon" src={iconLangEn}/></Radio.Button>}
                          {languages.includes("pt") &&
                              <Radio.Button value="pt"><img className="language-icon" src={iconLangBr}/></Radio.Button>}
                        </Radio.Group>
                    }
                  </Col>
                  <Col span={handleSaveTemplate ? 3 : 6} style={{textAlign: 'center'}}>
                    <Checkbox disabled={!handleSaveTemplate || !hasSigner} onChange={handleSaveTemplate && handleChangeSign}
                              checked={hasSigner && hasSign}>{t('forms.label.electronic_signature', {ns: 'forms'})}</Checkbox>
                  </Col>
                  {handleSaveTemplate &&
                      <Col span={3} style={{textAlign: 'right'}}>
                        <Button onClick={saveForm} type="primary">{t('forms.manager.saveTemplate')}</Button>
                      </Col>
                  }
                </Row>

                <br/>
                <Row>
                  <Col span={12} style={{ display: 'flex', alignItems: 'center' }}>
                    {mode === 'list' && (
                        <Form.Item style={{ marginBottom: 0, width: '100%' }}>
                          <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                            <label style={{ fontWeight: 'bold', marginRight: 8, whiteSpace: 'nowrap' }}>
                              {t("forms.manager.title.name")}:
                            </label>
                            {getFieldDecorator('form_title', {
                              initialValue: form?.title?.[lang] || '',
                              rules: [
                                {
                                  required: true,
                                  whitespace: true,
                                  message: t('messages.aml.requestedField', { ns: 'translations' }),
                                },
                                {
                                  max: 80,
                                  message: t('forms.manager.section.maxLength', { ns: 'forms', max: 80 }),
                                },
                              ],
                            })(
                                <Input
                                    placeholder={t('forms.manager.section.namePlaceholder')}
                                    size="small"
                                    style={{ flex: 1 }}
                                    maxLength={80}
                                    onBlur={() => {
                                      formDecorator.validateFields((err, values) => {
                                        if (!err) {
                                          handleChangeTitle(values.form_title);
                                        }
                                      });
                                    }}
                                />
                            )}
                          </div>
                        </Form.Item>
                    )}
                  </Col>
                </Row>
                <br/>
                {mode === 'list' ?
                  <>
                    <Row className="titles-section">
                      <Col span={9}>{t('forms.manager.section.name')}</Col>
                      <Col span={6}>{t('forms.manager.section.type')}</Col>
                      <Col span={3} className="center">{t('forms.manager.section.active')}</Col>
                      {handleSaveTemplate &&
                          <>
                            <Col span={3} className="center">{t('forms.manager.section.edit')}</Col>
                            <Col span={3} className="center">{t('forms.manager.section.order')}</Col>
                          </>
                      }
                    </Row>

                    <DragDropContext onDragEnd={onDragEnd}>
                      <Droppable droppableId="droppable">
                        {(provided, snapshot) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                            >
                              {sections.map((section, index) =>
                                  <Draggable key={section.id} draggableId={section.id} index={index}>
                                    {(provided, snapshot) =>
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={getItemStyle(
                                                snapshot.isDragging,
                                                provided.draggableProps.style
                                            )}
                                        >
                                          <Row className="rows-section">
                                            <Col span={9}><Input value={section.name} disabled={!handleSaveTemplate}
                                                                  placeholder={t('forms.manager.section.namePlaceholder')}
                                                                  onChange={(e) => handleChangeName(index, e.target.value)}
                                                                  onBlur={handleBlurTitle} size="small"/></Col>
                                            <Col span={6}>
                                              {getTypeSection(section.type)}
                                            </Col>
                                            <Col span={3} className="center"><Checkbox
                                                checked={section.status === 'ACTIVE'} disabled={!handleSaveTemplate}
                                                onChange={(e) => changeActiveSection(index, e.target.checked)}/></Col>
                                            {handleSaveTemplate &&
                                                <>
                                                  <Col span={3} className="tools center">
                                                    <Tooltip title={t('forms.manager.section.edit')}>
                                                      <Button icon="edit" size="small"
                                                              disabled={section.type === null || section.type === undefined}
                                                              onClick={(e) => editSection(section)}/>
                                                    </Tooltip>
                                                    <Popconfirm 
                                                      title={t('forms.manager.section.confirmClone')}
                                                      onConfirm={(e) => cloneSection(section)}
                                                      cancelText={t('messages.aml.cancel', {ns: 'translations' })}
                                                    >
                                                      <Button icon="copy" size="small"/>
                                                    </Popconfirm>
                                                    <Popconfirm 
                                                      title={t('forms.manager.section.confirmDelete')}
                                                      onConfirm={(e) => deleteSection(index)}
                                                      cancelText={t('messages.aml.cancel', {ns: 'translations' })}
                                                    >
                                                      <Button icon="delete" size="small"/>
                                                    </Popconfirm>
                                                  </Col>
                                                  <Col span={3} className="drag-area center">
                                                    <Icon type="drag"/>
                                                  </Col>
                                                </>
                                            }
                                          </Row>
                                        </div>
                                    }
                                  </Draggable>
                              )}
                            </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                  </>
                : mode === 'design' &&
                  <FormEdit currentUser={currentUser} form={form}
                            refreshSection={handleSaveTemplate && refreshSection} closeSection={closeSection}
                            setForm={setForm} lang={lang}/>
                }
                <div style={{display: mode === "preview" ? "" : "none"}}>
                  <Preview currentUser={currentUser} form={form} lang={lang}/>
                </div>

                {isVisibleNewSection &&
                    <Modal
                        title={t("forms.manager.section.new.title", {ns: "forms"})}
                        className="form-manager-modal-new-section"
                        footer={null}
                        visible={true}
                        onOk={closeModalSectionHandler}
                        onCancel={closeModalSectionHandler}>
                      <ModalNewSection handlerAddSection={handlerAddSection}/>
                    </Modal>
                }
              </div>
          }
        </formsContext.Provider>
      }
    </div>
  )
}
export default Form.create()(FormDetail);
